import React, { FC } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { Grid } from '@material-ui/core'

import PackageCard from '~/components/cards/PackageCard/PackageCard'

import {
  actions,
  getPackages,
  hasLoadingPackages
} from '~/state/modules/package'
import { capitalizeFirstLetter } from '~/utils/functions'

import { Package } from '~/models/Package'

type Props = {
  onClick?: (p: any) => void
  disableFeatures?: boolean
  buttonText?: string
  numberOfSkeletons?: number
}

const Packages: FC<Props> = ({
  onClick,
  disableFeatures,
  buttonText,
  numberOfSkeletons = 3
}) => {
  const dispatch = useDispatch()
  const packages = useSelector(getPackages)
  const loading = useSelector(hasLoadingPackages)

  const placeholderPackages = new Array(numberOfSkeletons).fill({}) as Package[]

  return (
    <>
      <Grid container justifyContent="center" spacing={3}>
        {(loading ? placeholderPackages : packages).map((p) => (
          <Grid item xs={12} md={6} lg={4} key={p.name}>
            <PackageCard
              loading={loading}
              title={capitalizeFirstLetter(p.name || '')}
              price={p.price?.cents}
              currency={p.price?.currency_iso}
              features={p.features}
              buttonText={buttonText}
              packageType={p.type}
              onClick={(): void => {
                onClick(p)
                dispatch(actions.setPackage(p.id))
              }}
              disableFeatures={disableFeatures}
            />
          </Grid>
        ))}
      </Grid>
    </>
  )
}

export default Packages
